import "./button.css";
function ButtonOnly({ btnValue, btnClass, onFinish, disabled }) {
  return (
    <button className={btnClass} onClick={onFinish} disabled={disabled}>
      {btnValue}
    </button>
  );
}
export default ButtonOnly;
